'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "CheckableButton": "Polaris-CheckableButton",
  "Checkbox": "Polaris-CheckableButton__Checkbox",
  "Label": "Polaris-CheckableButton__Label"
};

exports.default = styles;
